module.exports = __webpack_public_path__ + "media/1_12.b56dd027.wav";